/*
 * Wraps a plain-text element in per-line or per-word masks so the text can be
 * revealed from behind its own baseline. Only touches elements whose content is
 * a single text node, so rich-text fields are left alone.
 */

const originals = new WeakMap()

function canSplit(el) {
	if (!el) return false
	if (el.children.length > 0) return false
	return el.textContent.trim().length > 0
}

function wordSpans(text) {
	return text
		.trim()
		.split(/\s+/)
		.map((word) => {
			const outer = document.createElement('span')
			outer.className = 'm-word'
			const inner = document.createElement('span')
			inner.className = 'm-word__inner'
			inner.textContent = word
			outer.appendChild(inner)
			return outer
		})
}

function appendWithSpaces(target, spans) {
	spans.forEach((span, index) => {
		if (index > 0) target.appendChild(document.createTextNode(' '))
		target.appendChild(span)
	})
}

export function splitWords(el) {
	if (!canSplit(el)) return false

	const text = originals.get(el) || el.textContent
	originals.set(el, text)

	const spans = wordSpans(text)
	el.textContent = ''
	appendWithSpaces(el, spans)

	spans.forEach((span, index) => {
		span.querySelector('.m-word__inner').style.setProperty('--m-index', index)
	})

	el.classList.add('is-split')
	return true
}

export function splitLines(el) {
	if (!canSplit(el)) return false

	const text = originals.get(el) || el.textContent
	originals.set(el, text)

	const spans = wordSpans(text)
	el.textContent = ''
	appendWithSpaces(el, spans)

	/* Group the measured words into the lines the browser actually laid out. */
	const lines = []
	let currentTop = null
	spans.forEach((span) => {
		const top = span.offsetTop
		if (currentTop === null || Math.abs(top - currentTop) > 2) {
			currentTop = top
			lines.push([])
		}
		lines[lines.length - 1].push(span.textContent)
	})

	el.textContent = ''
	lines.forEach((words, index) => {
		const line = document.createElement('span')
		line.className = 'm-line'
		const inner = document.createElement('span')
		inner.className = 'm-line__inner'
		inner.textContent = words.join(' ')
		inner.style.setProperty('--m-index', index)
		line.appendChild(inner)
		el.appendChild(line)
	})

	el.classList.add('is-split')
	return true
}

export function resetSplit(el) {
	const text = originals.get(el)
	if (text === undefined) return
	el.classList.remove('is-split')
	el.textContent = text
}
